import { getSevColor } from '@/constants'
import type { SliceMetrics } from '@/analysis/searchContract'
import type { LayerKey, Row, Severity } from './types'
import { asSeverity, formatLayerValue } from './format'

type Props = { row: Row; layer: LayerKey }

const METRIC_FOR_LAYER: Record<LayerKey, keyof SliceMetrics> = {
  demuxInRate: 'demuxInRate',
  demuxToDecodeLagMs: 'demuxToDecodeLag',
  renderInOutGap: 'renderRatio',
  downloadKbps: 'downloadKbps',
}

const readLayer = (row: Row, layer: LayerKey): { value: number | null; tier: Severity | null } => {
  const key = METRIC_FOR_LAYER[layer]
  const cell = row.metrics?.[key]
  return {
    value: typeof cell?.displayValue === 'number' && Number.isFinite(cell.displayValue) ? cell.displayValue : null,
    tier: asSeverity(cell?.tier),
  }
}

export default function HexCell({ row, layer }: Props) {
  const { value, tier } = readLayer(row, layer)
  const text = formatLayerValue(layer, value, tier)
  const key = METRIC_FOR_LAYER[layer]
  const reason = row.metrics?.[key]?.tierReason
  const title = [
    text,
    tier == null ? 'no data' : `tier ${tier}`,
    reason ? `reason: ${reason}` : null,
  ].filter(Boolean).join(' · ')
  return (
    <div style={{ color: getSevColor(tier), fontWeight: 700 }} title={title}>
      {text}
    </div>
  )
}
